import DataGrid from "components/data-grid/DataGrid";
import {
  setBreadCrumbs,
  setCurrent,
  setNavigationComponents,
} from "features/navigation/navigationSlice";
import React, { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import PrimaryButton from "ui/buttons/PrimaryButton";
import { columns } from "./columns";
import { useNavigate } from "react-router-dom";
import DropDownButton from "ui/buttons/DropDownButton";
import { PencilAltIcon, XIcon } from "@heroicons/react/outline";
import Card from "ui/Card";

export default function Assesments() {
  let navigate = useNavigate();
  let dispatch = useDispatch();
  let location = useLocation();

  const isListView =
    location.pathname === "/assesments" || location.pathname === "/assesments/";

  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [tempSelectedStatuses, setTempSelectedStatuses] = useState([]);
  const [showFilter, setShowFilter] = useState(false);

  let userData = useSelector((state) => state.data.userData);
  let permissions = userData?.permissions;

  React.useEffect(() => {
    if (permissions && permissions[0].length > 0) {
      if (!permissions[0].includes("r-asses")) {
        navigate("/401");
      }
    }
  }, []);

  React.useEffect(() => {
    dispatch(
      setCurrent({
        name: "Assesments",
      })
    );
    dispatch(
      setNavigationComponents(
        <PrimaryButton
          title="New Assesment"
          onClick={() => navigate("/assesments/create")}
        />
      )
    );
    dispatch(
      setBreadCrumbs([
        {
          name: "Home",
          path: "/home",
        },
        {
          name: "Assesments",
          path: "/outlets",
        },
      ])
    );
  }, []);

  const statusOptions = [
    { value: "paid", label: "Paid" },
    { value: "sent", label: "Sent" },
    { value: "pay_later", label: "Pay_Later" },
  ];

  const toggleFilter = () => {
    if (!showFilter) {
      setTempSelectedStatuses(selectedStatuses);
    }
    setShowFilter(!showFilter);
  };

  const handleCheckboxChange = (value) => {
    setTempSelectedStatuses((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  const applyFilters = () => {
    setSelectedStatuses(tempSelectedStatuses);
    setShowFilter(false);
  };

  const cancelFilter = () => {
    setShowFilter(false);
  };

  const filterParams =
    selectedStatuses.length > 0
      ? { status: selectedStatuses.join(",") }
      : undefined;

  const externalParams = useMemo(
    () => (filterParams ? { ...filterParams } : {}),
    [filterParams ? filterParams.status : ""]
  );

  const cellFunction = (cell) => {
    if (cell.column.id === "ticketNumber") {
      return (
        <div
          onClick={() => {
            navigate("/assesments/view/" + cell.row.original.id, {
              state: cell.row.original,
            });
          }}
          className="flex flex-row items-center space-x-3 cursor-pointer"
        >
          <p className="hover:underline">{cell.value}</p>
        </div>
      );
    }
    if (cell.column.id === "actions") {
      return (
        <DropDownButton
          items={[
            {
              title: "Edit",
              icon: <PencilAltIcon className="h-5 w-5" />,
              path: "/outlets/edit/" + cell.row.original.id,
              state: cell.row.original,
            },
            {
              title: "Delete",
              icon: <XIcon className="h-5 w-5" />,
              path: "/outlets/delete/" + cell.row.original.id,
              state: cell.row.original,
            },
          ]}
          title="Actions"
          icon={<i className="fas fa-ellipsis-v"></i>}
          className=""
          setSelected={(item) => {
            console.log(item);
          }}
          path="/outlets/"
        />
      );
    }
    if (cell.column.id === "status") {
      const status = cell.value;
      const statusClass =
        status === "paid"
          ? "bg-teal-100 text-teal-800"
          : status === "sent"
            ? "bg-amber-100 text-amber-800"
            : status === "pay_later" || status === "paid_later"
              ? "bg-blue-100 text-blue-800"
              : "bg-gray-100 text-gray-800";
      return (
        <span className={`px-2 inline-flex text-[10px] leading-5 rounded-full ${statusClass}`}>
          {status || "—"}
        </span>
      );
    }
    return cell.value;
  };

  return (
    <div className="relative overflow-scroll min-h-[80vh] ">
      {isListView && (
        <Card
          heading={"All Assesments"}
          description={"Type in the search field below to search for a inventory"}
        >
          <div className="relative flex space-y-3 flex-col w-full">
            <div className="relative">
              <div className="absolute top-0 right-0 z-10">
                <div className="relative">
                  <button
                    onClick={toggleFilter}
                    className="w-auto h-8 px-4 py-2 border rounded flex items-center space-x-2 text-sm bg-[#dce3ec] hover:bg-[#cbd5e1] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 shadow-sm transition-colors"
                  >
                    <span className="hidden sm:inline">Filter</span>
                    <span className="sm:hidden">
                      <i className="fas fa-filter"></i>
                    </span>
                    <i className="fas fa-filter hidden sm:inline"></i>
                    {selectedStatuses.length > 0 && (
                      <span className="ml-1 px-2 py-0.5 text-xs bg-blue-100 text-blue-800 rounded-full">
                        {selectedStatuses.length}
                      </span>
                    )}
                  </button>

                  {showFilter && (
                    <div className="absolute right-0 mt-2 w-screen sm:w-64 sm:max-w-xs -left-4 sm:left-auto bg-white border rounded shadow-lg z-20 p-4">
                      <p className="font-medium mb-2 text-gray-700 text-sm md:text-base">
                        Filter by Status
                      </p>
                      <div className="space-y-2 max-h-60 overflow-y-auto">
                        {statusOptions.map((option) => (
                          <label
                            key={option.value}
                            className="flex items-center space-x-2 cursor-pointer hover:bg-gray-50 p-1 rounded transition-colors"
                          >
                            <input
                              type="checkbox"
                              checked={tempSelectedStatuses.includes(option.value)}
                              onChange={() => handleCheckboxChange(option.value)}
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                            />
                            <span className="text-sm text-gray-700">
                              {option.label}
                            </span>
                          </label>
                        ))}
                      </div>
                      <div className="flex flex-col sm:flex-row justify-end gap-2 mt-4 pt-2 border-t border-gray-100">
                        <button
                          onClick={cancelFilter}
                          className="px-3 py-1.5 text-xs font-medium text-gray-700 bg-gray-100 rounded hover:bg-gray-200 transition-colors order-2 sm:order-1"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={applyFilters}
                          className="px-3 py-1.5 text-xs font-medium text-white bg-blue-600 rounded hover:bg-blue-700 transition-colors order-1 sm:order-2"
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <DataGrid
                key={`assesments-${selectedStatuses.join(",")}`}
                searchable={true}
                x_columns={columns}
                height={"h-[calc(100vh-230px)]"}
                api={"/admin/assesment"}
                showHeader={true}
                cellFunction={cellFunction}
                externalParams={externalParams}
                paginationMode="server"
                defaultPageSize={10}
                pageSizeOptions={[10, 25, 50,]}
              />
            </div>
          </div>
        </Card>
      )}
      <Outlet />
    </div>
  );
}